import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false, requireSuperAdmin = false, requireOperator = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="mono text-zinc-500 text-sm">INITIALIZING SESSION...</div>
      </div>
    );
  }
  if (!user) {
    // If unauth user was trying to access hidden console, keep them on that flow
    if (typeof window !== "undefined" && window.location.pathname.startsWith("/nvr-console")) {
      return <Navigate to="/nvr-console" replace />;
    }
    return <Navigate to="/login" replace />;
  }
  if (requireSuperAdmin && user.role !== "super_admin") return <Navigate to="/dashboard" replace />;
  if (requireOperator && !["operator", "super_admin"].includes(user.role)) {
    return <Navigate to="/nvr-console" replace />;
  }
  if (requireAdmin && !["admin", "super_admin"].includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
